@let vm = vm$();

<div class="p-24 h-100 w-100 flex-col gap-16">
  @if (vm.viewState !== 'LOADING' && vm.viewState !== 'INITIAL_EMPTY') {
    <div class="flex-row space-between-start">
      <div class="flex-col gap-16">
        <ui-search
          style="width: 285px"
          [placeholder]="'YOUTUBE.PLACEHOLDERS.SEARCH' | translate"
          [searchQuery]="vm.search"
          (searchQueryChange)="search.set($event)">
        </ui-search>
      </div>
      <ui-button type="secondary" [text]="'YOUTUBE.BUTTONS.ADD' | translate" (clickAction)="onAdd()"></ui-button>
    </div>
  }

  <div class="h-100 w-100">
    @switch (vm.viewState) {
      @case ('LOADING') {
        <div class="h-100 w-100 flex-col center-center">
          <ui-preloader [color]="loaderColor.blue"></ui-preloader>
        </div>
      }
      @case ('INITIAL_EMPTY') {
        <div class="h-100 w-100 flex-col center-center">
          <ui-no-data [imgSrc]="noData.imgSrc" [title]="noData.title | translate" [createButtonText]="noData.createButtonText | translate" (onCreate)="onAdd()"></ui-no-data>
        </div>
      }
      @case ('NO_RESULTS') {
        <div class="h-100 w-100 flex-col center-center">
          <ui-no-data [imgSrc]="noResults.imgSrc" [title]="noResults.title | translate"></ui-no-data>
        </div>
      }
      @case ('HAS_DATA') {
        <ui-dataset-table
          [data]="vm.filteredList"
          [config]="tableConfig()"
          (rowAction)="onRowAction($event)"
        ></ui-dataset-table>
      }
    }
  </div>
</div>
